import { render, staticRenderFns } from "./ApplePodcast.vue?vue&type=template&id=50b2954a&"
import script from "./ApplePodcast.vue?vue&type=script&lang=js&"
export * from "./ApplePodcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports